import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Typography from '@mui/material/Typography';
import { Fragment, useEffect, useRef } from 'react';
import useMountedState from 'react-use/lib/useMountedState';
import { createGetUpcomingTourneysOutbound } from '../../api/outbound/commonOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { PanelItemDivider } from '../../panels/panelItemDivider';
import { DEFAULT_BACKGROUND_DIVIDER_COLOR } from '../../styles/colors';
import { isLocalhostEnvironment } from '../../utils/utils';
import { OpenModalContainer } from '../openModalContainer';
import { TourneyDetailsDisplay } from './tourneyDetailsDisplay';
const UPDATE_INTERVAL_MS = isLocalhostEnvironment() ? 5000 : 60000;
function createMockUpcomingTourneys() {
    return [
        {
            id: 1,
            name: 'Mock Tourney 1',
            secsUntilStart: 300,
            timeUntilStartStr: '5 minutes',
            buyIn: 1000,
            currency: 'chips',
            frequencyCount: 1,
            frequencyUnitType: 'days',
            extraChipsToWin: 50000,
            extraJacksToWin: 0,
            infoMarkdown: "🦊 Let's play poker!\n\n- This will be fun.\n- I promise."
        },
        {
            id: 2,
            name: 'Mock Tourney 2',
            secsUntilStart: 10800,
            timeUntilStartStr: '3 hours',
            buyIn: 2000,
            currency: 'jacks',
            frequencyCount: 2,
            frequencyUnitType: 'months',
            extraChipsToWin: 0,
            extraJacksToWin: 10000,
            infoMarkdown: "🐸 Let's play even more poker!"
        }
    ];
}
export const UpcomingTourneysModal = ({ upcomingTourneys: propsUpcomingTourneys, refreshTimestamp, onClose }) => {
    const socketSend = useSocketSend();
    const isMounted = useMountedState();
    const timeoutId = useRef();
    const upcomingTourneys = !propsUpcomingTourneys.length && isLocalhostEnvironment() ? createMockUpcomingTourneys() : propsUpcomingTourneys;
    useEffect(() => {
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(() => {
            if (!isMounted()) {
                return;
            }
            if (isLocalhostEnvironment()) {
                console.log('requesting upcoming tourneys refresh...');
            }
            socketSend(createGetUpcomingTourneysOutbound());
        }, UPDATE_INTERVAL_MS);
    }, [socketSend, isMounted, refreshTimestamp]);
    useEffect(() => {
        return () => {
            if (isLocalhostEnvironment()) {
                console.log('clearing upcoming tourneys timeout on unmount...');
            }
            clearTimeout(timeoutId.current);
        };
    }, []);
    return (_jsx(OpenModalContainer, { title: 'Upcoming Tourneys*', onClose: onClose, maxWidth: 'md', children: _jsxs(DialogContent, { children: [_jsx(Typography, { variant: 'subtitle1', children: upcomingTourneys.map((tourneyDetails, i) => (_jsxs(Fragment, { children: [i > 0 && _jsx(PanelItemDivider, { color: DEFAULT_BACKGROUND_DIVIDER_COLOR, thicknessPx: 2 }), _jsx(TourneyDetailsDisplay, { tourneyDetails: tourneyDetails, isSingleView: false })] }, i))) }), upcomingTourneys.length > 0 && (_jsxs(_Fragment, { children: [_jsx(PanelItemDivider, { color: DEFAULT_BACKGROUND_DIVIDER_COLOR, thicknessPx: 2 }), _jsx(DialogContentText, { component: 'div', children: _jsx(Typography, { variant: 'subtitle2', children: "*This list shows only the next time a given series will run a tourney, not every tourney that will run." }) })] }))] }) }));
};
